import { Formik, Form as Bform } from "formik";
import { useCallback } from "react";
import { useEffect, useState } from "react";
import { string, object, number } from "yup";
import * as com from "../../Common";
import AsyncSelect from "react-select/async";

import {
  Col,
  Container,
  FloatingLabel,
  Form,
  Offcanvas,
  Row,
} from "react-bootstrap";
import ReactSelect from "react-select";
import Button from "./Button";
import moment from "moment";
import CustomOption from "../CustomOption";

export default function BulkCanvas({
  hideCanvas,
  displayCanvas,
  handleCloseFun,
  checkattr,
  submitbulkValues,
  tattle_id,
  isBulkUpload,
  users,
}) {
  
  const [attrforms, setAttrForms] = useState([]);
  const [state, setState] = useState({
    tattle_id: "",
    attachmentsupload: {},
  });
  useEffect(() => {
    setAttrForms(checkattr);
  }, [checkattr]);

  const defaultValue = (options, value) => {
    return options ? options.find((option) => option.value === value) : "";
  };

  const convertDateFormat = (date) => {
    let convertdate = moment(date).format("YYYY-MM-DD");
    return convertdate;
  };
  const getCompanyName = async (apiUrl) => {
    const response = await fetch(apiUrl);
    const rdata = await response.json();
    if (rdata.code === 200) {
      return rdata.data.map((item) => ({ label: item.value, value: item.id }));
    }
  };

  const loadAddress = async (api, evt, type) => {
    let url = api;
    url += evt ? evt : "";
    try {
      return new Promise((resolve, reject) => {
        if (type === "project") {
          fetch(url)
            .then(async (response) => {
              const dataresponse = await response.json();
              if (dataresponse.code === 200) {
                const { data } = dataresponse;
                const resdata = data.map((item) => ({
                  label: `${item.customer_tattle_uuid} - ${item.title}`,
                  value: item.customer_tattle_uuid,
                  url: item.url,
                }));
                resolve(resdata);
              }
            })
            .catch((error) => reject(error));
        }
        if (type == "external_api") {
          fetch(url)
            .then(async (response) => {
              const dataresponse = await response.json();
              const resdata = Object.entries(dataresponse).map(
                ([key, val]) => ({
                  label: `${key} - ${val.title}`,
                  value: key,
                  url: val.url,
                })
              );
              resolve(resdata);
            })
            .catch((error) => reject(error));
        }
        if (type === "api") {
          if (evt && state.apiData.length > 0) {
            const newatt = state.apiData.filter((item) =>
              item.label.toLowerCase().includes(evt.toLowerCase())
            );
            resolve(newatt);
            return;
          }
          fetch(url)
            .then(async (response) => {
              const dataresponse = await response.json();
              // console.log(dataresponse, 65461231456);
              const apidata = dataresponse.map((item) => ({
                label: item.value,
                value: item.id,
              }));
              setState((state) => {
                return {
                  ...state,
                  apiData: apidata,
                };
              });
              resolve(apidata);
            })
            .catch((error) => reject(error));
        }
        if (type === "release") {
          if (evt && state.apiData.length > 0) {
            const newatt = state.apiData.filter((item) =>
              item.label.toLowerCase().includes(evt.toLowerCase())
            );
            resolve(newatt);
            return;
          }
          fetch(url)
            .then(async (response) => {
              const dataresponse = await response.json();
              
              const apidata = dataresponse.map((item) => ({
                label: item.value,
                value: item.id,
              }));
              setState((state) => {
                return {
                  ...state,
                  apiData: apidata,
                };
              });
              resolve(apidata);
            })
            .catch((error) => reject(error));
        }
      });
    } catch (error) {}
  };

  const loadBoardData = async (evt, api) => {
    if (evt) {
    } else {
      const repp = await fetch(api);
      const rdata = await repp.json();
      const { code, data } = rdata;
      if (code === 200 && data.length > 0) {
        return data.map((item) => ({
          label: `${item.customer_tattle_uuid} - ${item.title}`,
          value: item.customer_tattle_uuid,
        }));
      }
    }
  };

  const customStyles = {
    menu: (provided, state) => {
      const height = state.options.length > 5 ? "180px" : "";
      return {
        ...provided,
        height: height,
        overflow: "hidden",
      };
    },
    multiValue: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center", // Align items center
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#333", // Customize label color if needed
    }),
  };

  const creteFormfun = useCallback((formik) => {
    let formcreate;
    if (attrforms.length > 0) {
      formcreate = attrforms.map((item, index) => {
        if (item.attribute_type === "tel") {
          return (
            <Col md={12} key={index}>
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>{" "}
                <input
                  className="form-control"
                  type={item.attribute_type}
                  placeholder={item.headerName}
                  name={item.field}
                  value={formik.values[item.field]}
                  onChange={formik.handleChange}
                />
                <Form.Control.Feedback
                  type="invalid"
                  style={
                    formik.errors[item.field] && {
                      display: "block",
                    }
                  }
                >
                  {formik.errors[item.field]}
                </Form.Control.Feedback>
              </div>
            </Col>
          );
        }
        if (item.attribute_type === "status") {
          const getOptions = item.options.map((it) => ({
            label: it.name,
            value: it._id,
          }));

          return (
            <Col md={12} key={index}>
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <ReactSelect
                  styles={customStyles}
                  options={getOptions}
                  onChange={(value) =>
                    formik.setFieldValue(item.field, value.value)
                  }
                />

                <Form.Control.Feedback
                  type="invalid"
                  style={
                    formik.errors[item.field] && {
                      display: "block",
                    }
                  }
                >
                  {formik.errors[item.field]}
                </Form.Control.Feedback>
              </div>
            </Col>
          );
        }
        if (item.attribute_type === "customer") {
          return (
            <Col md={12} key={index}>
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <input
                  type="email"
                  className="form-control"
                  placeholder={item.headerName}
                  name={item.field}
                  value={formik.values[item.field]}
                  onChange={formik.handleChange}
                />
                <Form.Control.Feedback
                  type="invalid"
                  style={
                    formik.errors[item.field] && {
                      display: "block",
                    }
                  }
                >
                  {formik.errors[item.field]}
                </Form.Control.Feedback>
              </div>
            </Col>
          );
        }
        if (item.attribute_type === "age") {
          return (
            <Col md={12} key={index}>
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <input
                  type="email"
                  className="form-control"
                  placeholder={item.headerName}
                  name={item.field}
                  value={formik.values[item.field]}
                  onChange={formik.handleChange}
                />

                <Form.Control.Feedback
                  type="invalid"
                  style={
                    formik.errors[item.field] && {
                      display: "block",
                    }
                  }
                >
                  {formik.errors[item.field]}
                </Form.Control.Feedback>
              </div>
            </Col>
          );
        }
        if (item.attribute_type === "account_manager") {
          return (
            <Col md={12} key={index}>
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <input
                  type="email"
                  className="form-control"
                  placeholder={item.headerName}
                  name={item.field}
                  value={formik.values[item.field]}
                  onChange={formik.handleChange}
                />

                <Form.Control.Feedback
                  type="invalid"
                  style={
                    formik.errors[item.field] && {
                      display: "block",
                    }
                  }
                >
                  {formik.errors[item.field]}
                </Form.Control.Feedback>
              </div>
            </Col>
          );
        }
        if (item.attribute_type === "cc") {
          return (
            <Col md={12} key={index}>
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <input
                  type="email"
                  className="form-control"
                  placeholder={item.headerName}
                  name={item.field}
                  value={formik.values[item.field]}
                  onChange={formik.handleChange}
                />

                <Form.Control.Feedback
                  type="invalid"
                  style={
                    formik.errors[item.field] && {
                      display: "block",
                    }
                  }
                >
                  {formik.errors[item.field]}
                </Form.Control.Feedback>
              </div>
            </Col>
          );
        }
        if (item.attribute_type === "category") {
          const getOptions = item.options.map((it) => ({
            label: it.name,
            value: it._id,
          }));

          return (
            <Col md={12} key={index}>
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <ReactSelect
                  options={getOptions}
                  onChange={(value) =>
                    formik.setFieldValue(item.field, value.value)
                  }
                />

                <Form.Control.Feedback
                  type="invalid"
                  style={
                    formik.errors[item.field] && {
                      display: "block",
                    }
                  }
                >
                  {formik.errors[item.field]}
                </Form.Control.Feedback>
              </div>
            </Col>
          );
        }
        if (item.attribute_type === "api") {
          return (
            <Col md={12} key={index}>
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <AsyncSelect
                  cacheOptions
                  defaultOptions
                  isClearable
                  styles={customStyles}
                  placeholder={item.headerName}
                  loadOptions={(evt) => loadAddress(item.api_url, evt, "api")}
                  onChange={(value) =>
                    formik.setFieldValue(item.field, !value ? "" : value.value)
                  }
                  name={item.field}
                />
              </div>

              <Form.Control.Feedback
                type="invalid"
                style={
                  formik.errors[item.field] && {
                    display: "block",
                  }
                }
              >
                {formik.errors[item.field]}
              </Form.Control.Feedback>
            </Col>
          );
        }
        if (item.attribute_type === "release") {
          return (
            <Col md={12} key={index}>
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <AsyncSelect
                  cacheOptions
                  defaultOptions
                  isClearable
                  styles={customStyles}
                  placeholder={item.headerName}
                  loadOptions={(evt) =>
                    loadAddress(item.api_url, evt, "release")
                  }
                  onChange={(value) =>
                    formik.setFieldValue(item.field, !value ? "" : value.value)
                  }
                  name={item.field}
                />
              </div>

              <Form.Control.Feedback
                type="invalid"
                style={
                  formik.errors[item.field] && {
                    display: "block",
                  }
                }
              >
                {formik.errors[item.field]}
              </Form.Control.Feedback>
            </Col>
          );
        }
        if (item.attribute_type === "er") {
          return (
            <Col md={12} key={index}>
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <AsyncSelect
                  cacheOptions
                  defaultOptions
                  isMulti={true}
                  loadOptions={(evt) => loadAddress(item.api_url, evt, "er")}
                  onChange={(value) =>
                    formik.setFieldValue(
                      item.field,
                      value.map((itt) => itt.value)
                    )
                  }
                  name={item.field}
                />
              </div>
            </Col>
          );
        }
        if (item.attribute_type === "number") {
          return (
            <Col md={12} key={index}>
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <input
                  type="number"
                  className="form-control"
                  placeholder={item.headerName}
                  name={item.field}
                  value={formik.values[item.field]}
                  onChange={formik.handleChange}
                />

                <Form.Control.Feedback
                  type="invalid"
                  style={
                    formik.errors[item.field] && {
                      display: "block",
                    }
                  }
                >
                  {formik.errors[item.field]}
                </Form.Control.Feedback>
              </div>
            </Col>
          );
        }
        if (item.attribute_type === "toggle") {
          return (
            <Col md={12} key={index}>
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <div class="form-check form-switch me-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    name={item.field}
                    value={formik.values[item.field]}
                    onChange={formik.handleChange}
                    // defaultValue={editField.rows[editField.field]}
                    // onChange={editField.toggleHandler}
                    id="flexSwitchCheckChecked"
                    // value={Boolean(editField.rows[editField.field]) || false}
                    // checked={Boolean(editField.rows[editField.field]) || false}
                  />
                  <label
                    class="form-check-label"
                    for="flexSwitchCheckChecked"
                  ></label>
                </div>

                <Form.Control.Feedback
                  type="invalid"
                  style={
                    formik.errors[item.field] && {
                      display: "block",
                    }
                  }
                >
                  {formik.errors[item.field]}
                </Form.Control.Feedback>
              </div>
            </Col>
          );
        }
        if (item.attribute_type === "assign_to" || item.attribute_type === "people") {
          const getoptions = Object?.keys(users || {})?.map((iop) => ({
            label: users[iop].name,
            value: users[iop].user_uuid,
            profile_image: users[iop].profile_image,
          }));

          return (
            <Col md={12} key={index}>
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <ReactSelect
                  options={getoptions}
                  isClearable
                  onChange={(value) =>
                    formik.setFieldValue(item.field, value ? value.value:"")
                  }
                  value={getoptions.find(it => it.value == formik.values[item.field])}
                  defaultValue={formik.values[item.field]}
                  components={{ Option: CustomOption }}
                  menuPlacement="auto"
                />

                <Form.Control.Feedback
                  type="invalid"
                  style={
                    formik.errors[item.field] && {
                      display: "block",
                    }
                  }
                >
                  {formik.errors[item.field]}
                </Form.Control.Feedback>
              </div>
            </Col>
          );
        }
        if (item.attribute_type === "company_name") {
          return (
            <AsyncSelect
              cacheOptions
              defaultOptions
              styles={customStyles}
              placeholder={item.headerName}
              isClearable
              loadOptions={(evt) => getCompanyName(item.api_url, evt, "api")}
              onChange={(value) => {
                formik.setFieldValue(item.field, !value ? "" : value.value);
              }}
              name={item.field}
            />
          );
        }
        if (item.attribute_type === "text") {
          return (
            <Col md={12} key={index}>
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <input
                  className="form-control"
                  type={item.attribute_type}
                  placeholder={item.headerName}
                  name={item.field}
                  value={formik.values[item.field]}
                  onChange={formik.handleChange}
                  autoComplete="off"
                />
                <Form.Control.Feedback
                  type="invalid"
                  style={
                    formik.errors[item.field] && {
                      display: "block",
                    }
                  }
                >
                  {formik.errors[item.field]}
                </Form.Control.Feedback>
              </div>
            </Col>
          );
        }
        if (item.attribute_type === "checkbox") {
          return (
            <Col md={12} key={index}>
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <input
                  className="form-check-input m-1"
                  type={item.attribute_type}
                  placeholder={item.headerName}
                  name={item.field}
                  value={formik.values[item.field]}
                  onChange={formik.handleChange}
                />
                <Form.Control.Feedback
                  type="invalid"
                  style={
                    formik.errors[item.field] && {
                      display: "block",
                    }
                  }
                >
                  {formik.errors[item.field]}
                </Form.Control.Feedback>
              </div>
            </Col>
          );
        }
        if (item.attribute_type === "date") {
          return (
            <Col md={12} key={index}>
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <input
                  className="form-control"
                  type={item.attribute_type}
                  placeholder={item.headerName}
                  name={item.field}
                  value={formik.values[item.field]}
                  onChange={formik.handleChange}
                />
                <Form.Control.Feedback
                  type="invalid"
                  style={
                    formik.errors[item.field] && {
                      display: "block",
                    }
                  }
                >
                  {formik.errors[item.field]}
                </Form.Control.Feedback>
              </div>
            </Col>
          );
        }
        if (item.attribute_type === "email") {
          return (
            <Col md={12} key={index}>
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <input
                  className="form-control"
                  type={item.attribute_type}
                  placeholder={item.headerName}
                  name={item.field}
                  value={formik.values[item.field]}
                  onChange={formik.handleChange}
                />
                <Form.Control.Feedback
                  type="invalid"
                  style={
                    formik.errors[item.field] && {
                      display: "block",
                    }
                  }
                >
                  {formik.errors[item.field]}
                </Form.Control.Feedback>
              </div>
            </Col>
          );
        }
        if (item.attribute_type === "textarea") {
          return (
            <Col md={12} key={index}>
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <textarea
                  className="form-control"
                  placeholder={item.headerName}
                  name={item.field}
                  value={formik.values[item.field]}
                  isValid={
                    formik.touched[item.field] && !formik.errors[item.field]
                  }
                  isInvalid={!!formik.errors[item.field]}
                  onChange={formik.handleChange}
                />
                <Form.Control.Feedback
                  type="invalid"
                  style={
                    formik.errors[item.field] && {
                      display: "block",
                    }
                  }
                >
                  {formik.errors[item.field]}
                </Form.Control.Feedback>
              </div>
            </Col>
          );
        }
        if (
          item.attribute_type === "reporter" ||
          item.attribute_type === "people"
        ) {
          const { options } = item;
          const getoptions = Object?.keys(users || {})?.map((iop) => ({
            label: users[iop].name,
            value: users[iop].user_uuid,
            profile_image: users[iop].profile_image,
          }));
          return (
            <Col md={12} key={index} className="mb-3">
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <ReactSelect
                  placeholder={item.headerName}
                  onChange={(value) =>
                    formik.setFieldValue(item.field, value.value)
                  }
                  isClearable
                  name={item.field}
                  options={getoptions}
                />
                <Form.Control.Feedback
                  type="invalid"
                  style={
                    formik.errors[item.field] && {
                      display: "block",
                    }
                  }
                >
                  {formik.errors[item.field]}
                </Form.Control.Feedback>
              </div>
            </Col>
          );
        }
        if (item.attribute_type === "monitoring") {
          const getoptions = Object?.keys(users || {})?.map((iop) => ({
            label: users[iop].name,
            value: users[iop].user_uuid,
            profile_image: users[iop].profile_image,
          }));
          return (
            <Col md={12} key={index} className="mb-3">
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <ReactSelect
                  placeholder={item.headerName}
                  onChange={(value) =>
                    formik.setFieldValue(item.field, value.value)
                  }
                  name={item.field}
                  options={getoptions}
                />
                <Form.Control.Feedback
                  type="invalid"
                  style={
                    formik.errors[item.field] && {
                      display: "block",
                    }
                  }
                >
                  {formik.errors[item.field]}
                </Form.Control.Feedback>
              </div>
            </Col>
          );
        }
        if (item.attribute_type === "select") {
          const newopt = [];
          item.options.forEach((it) => {
            newopt.push({ label: it.option_name, value: it._id });
          });

          return (
            <Col md={12} key={index}>
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <ReactSelect
                  placeholder={item.headerName}
                  onChange={(value) =>
                    formik.setFieldValue(item.field, !value ? "" : value.value)
                  }
                  style={customStyles}
                  isClearable
                  name={item.field}
                  value={defaultValue(newopt, formik.values[item.field])}
                  options={newopt}
                />
                <Form.Control.Feedback
                  type="invalid"
                  style={
                    formik.errors[item.field] && {
                      display: "block",
                    }
                  }
                >
                  {formik.errors[item.field]}
                </Form.Control.Feedback>
              </div>
            </Col>
          );
        }
        if (item.attribute_type === "multi-select") {
          const newopt = [];
          item.options.forEach((it) => {
            newopt.push({ label: it.option_name, value: it._id });
          });

          return (
            <Col md={12} key={index}>
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <ReactSelect
                  placeholder={item.headerName}
                  onChange={(value) =>
                    formik.setFieldValue(item.field, !value ? "" : value.value)
                  }
                  styles={customStyles}
                  isMulti={true}
                  isClearable
                  name={item.field}
                  value={defaultValue(newopt, formik.values[item.field])}
                  options={newopt}
                />
                <Form.Control.Feedback
                  type="invalid"
                  style={
                    formik.errors[item.field] && {
                      display: "block",
                    }
                  }
                >
                  {formik.errors[item.field]}
                </Form.Control.Feedback>
              </div>
            </Col>
          );
        }
        if (item.attribute_type === "priority") {
          const newopt = [];
          item.options.forEach((it) => {
            newopt.push({ label: it.option_name, value: it._id });
          });
          return (
            <Col md={12} key={index}>
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <ReactSelect
                  placeholder={item.headerName}
                  onChange={(value) =>
                    formik.setFieldValue(item.field, !value ? "" : value.value)
                  }
                  isClearable
                  name={item.field}
                  value={defaultValue(newopt, formik.values[item.field])}
                  options={newopt}
                />
                <Form.Control.Feedback
                  type="invalid"
                  style={
                    formik.errors[item.field] && {
                      display: "block",
                    }
                  }
                >
                  {formik.errors[item.field]}
                </Form.Control.Feedback>
              </div>
            </Col>
          );
        }
        if (item.attribute_type === "radio") {
          return (
            <Col md={item.attribute_grid} key={index}>
              <div className="form-group mb-3">
                <label
                  className={item.is_required ? "form-label _required" : ""}
                >
                  {item.headerName}
                </label>
                <input
                  className="form-control"
                  type={item.attribute_type}
                  placeholder={item.headerName}
                  name={item.field}
                  value={formik.values[item.field]}
                  onChange={formik.handleChange}
                />
                <Form.Control.Feedback
                  type="invalid"
                  style={
                    formik.errors[item.field] && {
                      display: "block",
                    }
                  }
                >
                  {formik.errors[item.field]}
                </Form.Control.Feedback>
              </div>
            </Col>
          );
        }
      });
    }

    return formcreate;
  });

  let fields = [];
  attrforms.forEach((item) => {
    let validation = {};
    if (item.is_required && item.attribute_type === "tel") {
      const phoneRegExp =
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
      validation = {
        required: string()
          .required(com.firstUpper(item.headerName + " is required "))
          .matches(phoneRegExp, "Phone number is not valid")
          .max(10, "10 number is allowed"),
      };
    } else if (item.is_required && item.attribute_type === "text") {
      validation = {
        required: string().required(
          com.firstUpper(item.headerName + " is required ")
        ),
      };
    } else if (item.is_required && item.attribute_type === "textarea") {
      validation = {
        required: string()
          .trim()
          .required(com.firstUpper(item.headerName + " is required ")),
      };
    } else if (item.is_required && item.attribute_type === "select") {
      validation = {
        required: string().required(
          com.firstUpper(item.headerName + " is required ")
        ),
      };
    } else if (item.is_required && item.attribute_type === "checkbox") {
      validation = {
        required: string().required(
          com.firstUpper(item.headerName + " is required ")
        ),
      };
    } else if (item.is_required && item.attribute_type === "radio") {
      validation = {
        required: string().required(
          com.firstUpper(item.headerName + " is required ")
        ),
      };
    } else if (item.attribute_type === "tel") {
      const phoneRegExp =
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
      validation = {
        required: string()
          .matches(phoneRegExp, "Phone number is not valid")
          .max(10, "10 number is allowed"),
      };
    }

    fields.push({
      name: item.field,
      initialValue: "",
      type: item.attribute_type,
      ...validation,
    });
  });
  const initialValues = Object.fromEntries(
    fields.map((fiel) => [fiel.name, fiel.initialValue])
  );
  const validObject = Object.fromEntries(
    fields.map((fiel) => [fiel.name, fiel.required])
  );
  const userSchema = object().shape(validObject);

  return (
    <>
      <Offcanvas placement="end" show={displayCanvas} onHide={handleCloseFun}>
        <Offcanvas.Header closeButton className="border-bottom pb-2">
          <Offcanvas.Title>Bulk Operation</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="pt-0">
          <div className="mt-3">
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={userSchema}
              onSubmit={(values, { resetForm }) => {
                submitbulkValues(values);
                resetForm({ values: "" });
              }}
            >
              {(formik) => (
                <Bform>
                  <Row>{creteFormfun(formik)} </Row>

                  <Row>
                    <Col md={12} className="mt-4">
                      <Button
                        type="submit"
                        className="muBtn _blue float-start"
                        text={`${isBulkUpload ? "Saving..." : "Save"}`}
                        isDisabled={isBulkUpload}
                      />
                    </Col>
                  </Row>
                </Bform>
              )}
            </Formik>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
